import React, { useEffect, useState } from "react";
import { headerData } from "../ArraysTexts/HeaderText";
import MainLink from "../../Link";
import {ShopPay} from "../ShopPagePay";

const ucp_get_donate = `${MainLink()}api/ucp/get-donate`;

function ShopHeader({ typeIndex = 0 }) {
    const [donateBalance, setDonateBalance] = useState(0);
    const [isFavoritesPage, setIsFavoritesPage] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false); // Состояние модального окна

    useEffect(() => {
        const fetchDonate = async () => {
            try {
                const userId = localStorage.getItem("user-id");
                const userName = localStorage.getItem("user-login");
                const userPassword = localStorage.getItem("user-password");

                const urlWithParams = `${ucp_get_donate}?user_id=${encodeURIComponent(userId)}&user_name=${encodeURIComponent(userName)}&user_password=${encodeURIComponent(userPassword)}`;

                const response = await fetch(urlWithParams, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${localStorage.getItem("jwtToken")}`
                    },
                });

                if (!response.ok) {
                    throw new Error(`Ошибка HTTP! Статус: ${response.status}`);
                }

                const result = await response.json();
                setDonateBalance(result || 0);
            } catch (err) {
                console.error("Ошибка загрузки баланса:", err.message);
                setDonateBalance(0);
            }
        };
        fetchDonate();

        // Проверяем, находимся ли мы на странице "Избранное"
        const path = window.location.pathname;
        setIsFavoritesPage(path.includes("/ucp/shop/favorites"));
    }, []);

    const { buttonText, buttonLink } = headerData[typeIndex];

    return (
        <div className='ucp-shop-content-container'>
            <div className='ucp-header shop-header'>
                <div className="shop-header-buttons-container">
                    <a href="../../../../..">
                        <div className='logo-img shop-img' style={{ position: "absolute", marginTop: "25px" }}></div>
                    </a>
                    <button className='ucp-simple-blur-button ucp-button-back shop-button-back'
                            onClick={() => window.location.href = buttonLink}>
                        {buttonText}
                    </button>
                    <div className="shop-header-buttons-second-container">
                        <button
                            className={`ucp-simple-blur-button ucp-button-back-shop ${isFavoritesPage ? 'active' : ''}`}
                            onClick={() => window.location.href = "../../../../../ucp/shop/favorites"}>
                            ИЗБРАННОЕ
                        </button>
                        <span className="coin custom-coin-shop-height">
                            {donateBalance}
                            {/*<a href="/ucp/shop/pay">*/}
                                <span className="coin-plus" onClick={() => setIsModalOpen(true)}>+</span>
                            {/*</a>*/}
                        </span>
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <ShopPay onClose={() => setIsModalOpen(false)} />
            )}
        </div>
    );
}

export default ShopHeader;
